import React, { useEffect, useState } from "react";
import AllCtx from "../../uti-functions/allCtx";

function ChildrenDetails() {
  const {
    // monitor,
    adult,
    children,
    infant,
    allPassengers,

    tripType,
    flightArray,
    setTheFlightArray,
    chosenFlight,
    chosenFlightID,
    setTheChosenClass,
    setTheChosenClassPrice,
    chosenClass,
    chosenClassName,
    chosenClassPrice,
    setTheChosenFlight,
    setTheChosenFlightID,
    searchBookingResponse,
    setTheSearchBookingResponse,
    setTheChosenClassName,
    setTheClassChosen,
    classChosen,
    setTheSearchResultResponse,
    searchResultResponse,
    setTheAllPassengers,
    setTheChildrenArray,
    adultArray,
    childrenArray,
  } = AllCtx();

  var { infantArray } = AllCtx();

  const [childrenTitle, setChildrenTitle] = useState("");
  const [childrenGender, setChildrenGender] = useState("");
  const [childrenFirstName, setChildrenFirstName] = useState("");
  const [childrenLastName, setChildrenLastName] = useState("");
  const [childrenDOB, setChildrenDOB] = useState("");

  const [monitor, setMonitor] = useState(true);

  useEffect(() => {
    for (var i = 0; i < children; i++) {
      if (monitor) {
        childrenArray[i] = {
          type: "child",
          title: "Master",
          first_name: childrenFirstName,
          last_name: childrenLastName,
            gender: childrenGender,
            c_dob: childrenDOB,
          id: "Child " + (i + 1),
        };
      }
      localStorage.setItem(
        "childrenArray",
        JSON.stringify(childrenArray)
      );
      setMonitor(false);

      // if (localStorage.getItem("adultArray")) {
      //   setTheAdultArray(JSON.parse(localStorage.getItem("adultArray")));
      // }
    }
  }, [monitor]);

  function handleChildrenTitleChange(childID, titlePicked) {
    let newChildrenArray = [...childrenArray];
    let childrenInputToChange = newChildrenArray.find(
      (child) => child.id === childID
    );

    childrenInputToChange.title = titlePicked;

    setTheChildrenArray(newChildrenArray);
    setChildrenTitle(childrenInputToChange.title);

    return childrenInputToChange.title;
  }

  function handleChildrenGenderChange(childID, genderPicked) {
    let newChildrenArray = [...childrenArray];
    let childrenInputToChange = newChildrenArray.find(
      (child) => child.id === childID
    );
    childrenInputToChange.gender = genderPicked;
    setTheChildrenArray(newChildrenArray);
    setChildrenGender(childrenInputToChange.gender);
    return childrenInputToChange.gender;
  }

  function handleChildrenFirstNameChange(childID, firstNameTyped) {
    let newChildrenArray = [...childrenArray];
    let childrenInputToChange = newChildrenArray.find(
      (child) => child.id === childID
    );
    childrenInputToChange.first_name = firstNameTyped;
    setTheChildrenArray(newChildrenArray);
    setChildrenFirstName(childrenInputToChange.first_name);

    return childrenInputToChange.first_name;
  }

  function handleChildrenLastNameChange(childID, lastNameTyped) {
    let newChildrenArray = [...childrenArray];
    let childrenInputToChange = newChildrenArray.find(
      (child) => child.id === childID
    );
    childrenInputToChange.last_name = lastNameTyped;
    setTheChildrenArray(newChildrenArray);
    setChildrenLastName(childrenInputToChange.last_name);
    return childrenInputToChange.last_name;
  }

  function handleChildrenDOBChange(childID, dobChosen) {
    let newChildrenArray = [...childrenArray];
    let childrenInputToChange = newChildrenArray.find(
      (child) => child.id === childID
    );
    childrenInputToChange.c_dob = dobChosen;
    setTheChildrenArray(newChildrenArray);
    setChildrenDOB(childrenInputToChange.c_dob);
    return childrenInputToChange.c_dob;
  }

  return (
    <div>
      {childrenArray.map((child) => (
        <div key={child.id} className="mt-4">
          <div>
            <p className="text-pry-color mb-2 font-semibold">
              {
                 `${child.id} Details`}
            </p>
          </div>

          <div className=" border-2 rounded-md py-4 px-2 sm:px-5 md:px-2">
            <div className="mb-2">
              <p className="font-semibold text-sm">Passenger Info</p>
            </div>
            <div className="md:flex md:space-y-0 space-y-4 justify-between mb-3">
              {/* Title Select  */}
              <div className="md:w-[20%]">
                <div className="text-sm text-gray-500">Title</div>
                <select
                  className="text-xs w-full border-gray-300 rounded border-1"
                  name="title"
                  id="title"
                  onChange={(e) => {
                    handleChildrenTitleChange(child.id, e.target.value);
                    console.log(child.title);

                    console.log("childrenArray", childrenArray);
                    setTheAllPassengers(adultArray, childrenArray, infantArray);
                    console.log("allPa", allPassengers);
                  }}
                  // value={child.title}
                >
                  {/* <option value="">Select Title</option> */}
                  <option value="Master">Master</option>
                  <option value="Miss">Miss</option>
                  <option value="Ms">Ms</option>
                </select>
              </div>
              {/*  First Name   */}
              <div className="md:w-[38%]">
                <div className="text-sm text-gray-500">First Name</div>{" "}
                <input
                  placeholder="First Name"
                  onChange={(e) => {
                    handleChildrenFirstNameChange(child.id, e.target.value);

                    console.log("childrenArray", childrenArray);
                    setTheAllPassengers(adultArray, childrenArray, infantArray);
                    console.log("allPa", allPassengers);
                  }}
                  className="text-xs w-full border-gray-300 rounded border-1"
                  type="text"
                  name=""
                  id=""
                />
              </div>

              {/*  Last Name   */}
              <div className="md:w-[38%] ">
                <div className="text-sm text-gray-500">Last Name</div>{" "}
                <input
                  placeholder="Surname"
                  onChange={(e) => {
                    handleChildrenLastNameChange(child.id, e.target.value);

                    console.log("childrenArray", childrenArray);
                    setTheAllPassengers(adultArray, childrenArray, infantArray);
                    console.log("allPa", allPassengers);
                  }}
                  className="text-xs w-full border-gray-300 rounded border-1"
                  type="text"
                  name=""
                  id=""
                />
              </div>

      
                  </div>
                  <div className="md:flex justify-between mb-3 md:space-y-0 space-y-4">
           
           {/* DOB  */}
           <div className="md:w-[45%]">
             <div className="text-sm text-gray-500">DOB</div>
             <input
               onChange={(e) => {
                 handleChildrenDOBChange(child.id, e.target.value);

                 console.log("childrenArray", childrenArray);
                 setTheAllPassengers(
                   adultArray,
                   childrenArray,
                   infantArray
                 );
                 console.log("allPa", allPassengers);
               }}
               className="text-xs w-full outline-1 border-solid border-gray-300 rounded border-1"
               placeholder="Enter Email"
               type="date"
             />
           </div>{" "}
          
                              {/* Gender Select  */}

              <div className="md:w-[45%]">
                <div className="text-sm text-gray-500" htmlFor="">
                  Gender
                </div>
                <select
                  className="text-xs w-full border-gray-300 rounded border-1"
                  name="title"
                  id="title"
                  onChange={(e) => {
                    handleChildrenGenderChange(child.id, e.target.value);
                    console.log(child.gender);

                    console.log("childrenArray", childrenArray);
                    setTheAllPassengers(adultArray, childrenArray, infantArray);
                    console.log("allPa", allPassengers);
                  }}
                  // value={child.title}
                >
                  <option value="">Gender</option>
                  <option value="Male">Male</option>
                  <option value="Female">Female</option>
                  <option value="Undisclosed">Undisclosed</option>
                </select>
              </div>
         </div>
        
          </div>
        </div>
      ))}
    </div>
  );
}

export default ChildrenDetails;
